export { default as SatelliteSignal } from './SatelliteSignal'
